const EMP = 'EMP';
const CREATE_FILTER = 'create-filter';
const DATA_ACCESS_DURATION = 'data-access-duration';
const APP = 'APP';
const DRILLDOWN_LIMIT = 40;
const FUNNEL = 'funnel';
const commonFeatureNames = {
  EMP,
  CREATE_FILTER,
  DATA_ACCESS_DURATION,
  APP,
  DRILLDOWN_LIMIT,
  FUNNEL,
};
const featureNames = Object.assign({}, commonFeatureNames);

export default featureNames;
